import * as _ from "lodash";
import {MessageType} from "../PA.Core/PA.Core.IF.Basic";
import {ExchangeRateBO} from "./ExchangeRateBO";


export class ExchangeRateBOValidations{

    static ValidateEmptyFields(aBO: ExchangeRateBO): Promise<void> {

        return new Promise((resolve,error)=>{

            // Source ID
            if(_.isEmpty(aBO.WB_ExchangeRate.cif.SOURCE_ID) || _.isUndefined(aBO.WB_ExchangeRate.cif.SOURCE_ID) || _.isNull(aBO.WB_ExchangeRate.cif.SOURCE_ID)){
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'sourceid',
                        type: MessageType.Error,
                        title: "Source cannot be empty",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('sourceid')
            }



            if (_.isEmpty(aBO.WB_ExchangeRate.cif.EXCHANGE_RATE_TYPE_NAME) || _.isUndefined(aBO.WB_ExchangeRate.cif.EXCHANGE_RATE_TYPE_NAME) ||_.isNull(aBO.WB_ExchangeRate.cif.EXCHANGE_RATE_TYPE_NAME)) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'Emptyname',
                        type: MessageType.Error,
                        title: "Exchange Rate Type Name cannot be empty",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('Emptyname')
            }

            if (_.isEmpty(aBO.WB_ExchangeRate.cif.EXCHANGE_RATE_TYPE_ID) || _.isNull(aBO.WB_ExchangeRate.cif.EXCHANGE_RATE_TYPE_ID)) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'EmptyId',
                        type: MessageType.Error,
                        title: "Exchange Rate Type ID cannot be empty",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('EmptyId')
            }


            if(aBO.WB_ExchangeRate.cif.WB_CURRENCY_ID_REF==0 || _.isUndefined(aBO.WB_ExchangeRate.cif.WB_CURRENCY_ID_REF) || _.isNull(aBO.WB_ExchangeRate.cif.WB_CURRENCY_ID_REF)){
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'refcurrency',
                        type: MessageType.Error,
                        title: "Reference Currency cannot be empty",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('refcurrency')
            }

            // Validating the Grid
            const activeExchangeRateMRRows=_.filter(aBO.WB_ExchangeRate.WB_ExchangeRateMRRows,(r)=>r.isActive)
            let exchangeRateMRSet=new Set()
            let rates:number[]=[]
            let fromToCurrencyCheck:boolean
            let emptyValuesCheck:boolean
            _.forEach(activeExchangeRateMRRows,(row)=>{
                if(aBO.WB_ExchangeRate.cif.WB_CURRENCY_ID_REF!==0){
                    row.cif.WB_CURRENCY_ID_FROM=_.toNumber(aBO.WB_ExchangeRate.cif.WB_CURRENCY_ID_REF)
                }
                let value="WB_CURRENCY_ID_FROM:"+ row.cif.WB_CURRENCY_ID_FROM+
                    ",WB_CURRENCY_ID_TO:"+ row.cif.WB_CURRENCY_ID_TO+
                    ",EFFECTIVE_START_DT:"+ row.cif.EFFECTIVE_START_DT;

                exchangeRateMRSet.add(value)

                if(typeof row.cif.WB_CURRENCY_ID_TO=== "string"){
                    row.cif.WB_CURRENCY_ID_TO= _.toNumber(row.cif.WB_CURRENCY_ID_TO)
                }


                rates.push(row.cif.EXCHANGE_RATE)
                if(row.cif.WB_CURRENCY_ID_FROM===row.cif.WB_CURRENCY_ID_TO && row.cif.WB_CURRENCY_ID_TO!==0)
                {fromToCurrencyCheck=true}
                if(row.cif.WB_CURRENCY_ID_FROM===0 || _.isUndefined(row.cif.WB_CURRENCY_ID_FROM) || _.isNull(row.cif.WB_CURRENCY_ID_FROM)||
                    row.cif.WB_CURRENCY_ID_TO===0 || _.isUndefined(row.cif.WB_CURRENCY_ID_TO)|| _.isNull(row.cif.WB_CURRENCY_ID_TO) ||
                    row.cif.EFFECTIVE_START_DT==="" || _.isUndefined(row.cif.EFFECTIVE_START_DT) || _.isNull(row.cif.EFFECTIVE_START_DT) ||
                    row.cif.EXCHANGE_RATE===0 || _.isUndefined(row.cif.EXCHANGE_RATE)|| _.isNull(row.cif.EXCHANGE_RATE))
                { emptyValuesCheck=true}
            })

            // Check if any value in the grid is empty
            if(emptyValuesCheck){
                aBO.ValidateMessageProvider.addMessage(
                    {
                        type: MessageType.Error,
                        code: 'emptyValuesCheck',
                        title: `All fields are required in the grid.`,
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('emptyValuesCheck');
            }
            // Check From and To Currency on same row
            if(fromToCurrencyCheck){
                aBO.ValidateMessageProvider.addMessage(
                    {
                        type: MessageType.Error,
                        code: 'fromToCurrencyCheck',
                        title: `From and To Currency cannot be the same selection.`,
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('fromToCurrencyCheck');
            }

            // check non-zero Rate
            let ratesCheck= rates.some(val=> val <= 0)
            if(ratesCheck){
                aBO.ValidateMessageProvider.addMessage(
                    {
                        type: MessageType.Error,
                        code: 'nonZero',
                        title: `Rate must be a value greater than zero.`,
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('nonZero');
            }


            // Check duplicate Rows
            if(activeExchangeRateMRRows.length !== exchangeRateMRSet.size){
                aBO.ValidateMessageProvider.addMessage(
                    {
                        type: MessageType.Error,
                        code: 'sameValue',
                        title: `Valid From date is the same as existing record with From and To Currency combination.`,
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('sameValue');
            }

            resolve()
        })
    }


}